import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiDownload, FiStar, FiUsers, FiHeart } = FiIcons;

const Download = () => {
  return (
    <section id="download" className="py-20 px-6 bg-gradient-to-br from-rose-primary via-rose-secondary to-rose-accent">
      <div className="container mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto"
        >
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Ready to Transform
            <br />
            Your Gift Giving?
          </h2>
          
          <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-3xl mx-auto">
            Join thousands of happy users who've made gift giving effortless with Gifter's Choice.
          </p>

          {/* App Store Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6 mb-16">
            <motion.a
              href="#"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-white text-rose-primary px-8 py-4 rounded-2xl font-bold text-lg flex items-center space-x-3 shadow-2xl hover:shadow-3xl transition-all min-w-[250px]"
            >
              <SafeIcon icon={FiDownload} className="text-2xl" />
              <div className="text-left">
                <div className="text-xs text-gray-500">Download on the</div>
                <div className="text-lg font-bold">App Store</div>
              </div>
            </motion.a>

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="border-2 border-white text-white px-8 py-4 rounded-2xl font-bold text-lg hover:bg-white hover:text-rose-primary transition-all min-w-[200px]"
            >
              Coming Soon to Android
            </motion.button>
          </div>

          {/* Social Proof */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
            className="grid grid-cols-1 md:grid-cols-3 gap-8 bg-white/10 backdrop-blur-sm rounded-2xl p-8"
          >
            <div className="text-center text-white">
              <SafeIcon icon={FiUsers} className="text-3xl mb-4 mx-auto" />
              <div className="text-2xl font-bold mb-2">10,000+</div>
              <div className="text-white/80">Active Users</div>
            </div>
            
            <div className="text-center text-white">
              <SafeIcon icon={FiStar} className="text-3xl mb-4 mx-auto" />
              <div className="text-2xl font-bold mb-2">4.9★</div>
              <div className="text-white/80">App Store Rating</div>
            </div>
            
            <div className="text-center text-white">
              <SafeIcon icon={FiHeart} className="text-3xl mb-4 mx-auto" />
              <div className="text-2xl font-bold mb-2">50,000+</div>
              <div className="text-white/80">Lists Created</div>
            </div>
          </motion.div>

          {/* Testimonial */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            viewport={{ once: true }}
            className="mt-12 bg-white/10 backdrop-blur-sm rounded-2xl p-8"
          >
            <div className="flex justify-center mb-4">
              {[...Array(5)].map((_, i) => (
                <SafeIcon key={i} icon={FiStar} className="text-yellow-300 text-xl" />
              ))}
            </div>
            <blockquote className="text-xl text-white/90 italic mb-4">
              "Gifter's Choice completely changed how my family handles gift giving. No more duplicate gifts or wondering what someone actually wants!"
            </blockquote>
            <div className="text-white/80">
              — Sarah M., Happy User
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Download;